import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import styles from './floating-footer.less';

const FloatingFooter = ({ visible, contentWrapperClassName, children }) =>
  ReactDOM.createPortal(
    <div
      className={cx(styles.floatingFooter, {
        [styles.show]: visible,
      })}
    >
      <div className={cx(styles.contentWrapper, contentWrapperClassName)}>
        {children}
      </div>
    </div>,
    document.getElementById('root'),
  );

FloatingFooter.defaultProps = {
  visible: true,
  contentWrapperClassName: undefined,
  children: undefined,
};

FloatingFooter.propTypes = {
  visible: PropTypes.bool,
  contentWrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

export default FloatingFooter;
